import useGetApi from 'src/api/useGetApi';
import {
  GetDivisionsResponse,
  GetDivisionsWithTagsResponse,
} from 'src/types/application/Division';

export const useDivisions = (enabled?: boolean) => {
  return useGetApi<GetDivisionsWithTagsResponse>({
    endpoint: 'organization/divisions',
    options: {
      enabled,
    },
  });
};

export default useDivisions;
